import {
  FETCH_PAYMENT_SUCCESS,
  FETCH_PAYMENT_FAILED,
  CLEAR_PAYMENT,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case FETCH_PAYMENT_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_PAYMENT:
      return { ...initialState, status: 'clear' };
    default:
      return state;
  }
};
